export const getRouteCoordinates = state => state.route.coordinates;
